import { HealthPlanCode } from '../../Enums/HealthPlanCode.enum';
import { Country } from '../../Enums/Country.enum';

interface HealthPlanPricing {
	priceForPresentConsultation: number;
	priceForTelemedicineConsultation: number;
	priceForSupportActivitiesPlan: number;
	fixedPriceForHealthPlan: number;
	telemedicineDiscount?: number;
	saleDiscount: number;
}

const HealthPlanPricingMexico: Record<string, HealthPlanPricing> = {
	[HealthPlanCode.DIABETES]: {
		priceForPresentConsultation: 1600,
		priceForTelemedicineConsultation: 1600,
		priceForSupportActivitiesPlan: 224,
		fixedPriceForHealthPlan: 6490,
		saleDiscount: 10,
	},
	[HealthPlanCode.BABY]: {
		priceForPresentConsultation: 1100,
		priceForTelemedicineConsultation: 1100,
		priceForSupportActivitiesPlan: 236,
		fixedPriceForHealthPlan: 1800,
		saleDiscount: 10,
	},
};

const HealthPlanPricingEcuador: Record<string, HealthPlanPricing> = {
	[HealthPlanCode.DIABETES]: {
		priceForPresentConsultation: 35,
		priceForTelemedicineConsultation: 30,
		priceForSupportActivitiesPlan: 12,
		fixedPriceForHealthPlan: 320,
		telemedicineDiscount: 14.28,
		saleDiscount: 10,
	},
	[HealthPlanCode.BABY]: {
		priceForPresentConsultation: 35,
		priceForTelemedicineConsultation: 30,
		priceForSupportActivitiesPlan: 12.5,
		fixedPriceForHealthPlan: 100,
		telemedicineDiscount: 14.28,
		saleDiscount: 10,
	},
};

const HealthPlanPricingColombia: Record<string, HealthPlanPricing> = {
	[HealthPlanCode.DIABETES]: {
		priceForPresentConsultation: 180000,
		priceForTelemedicineConsultation: 170000,
		priceForSupportActivitiesPlan: 43600,
		fixedPriceForHealthPlan: 1535000,
		telemedicineDiscount: 5.55,
		saleDiscount: 10,
	},
	[HealthPlanCode.BABY]: {
		priceForPresentConsultation: 180000,
		priceForTelemedicineConsultation: 170000,
		priceForSupportActivitiesPlan: 44200,
		fixedPriceForHealthPlan: 386000,
		telemedicineDiscount: 5.55,
		saleDiscount: 10,
	},
};

const HealthPlanPricingPeru: Record<string, HealthPlanPricing> = {
	[HealthPlanCode.DIABETES]: {
		priceForPresentConsultation: 130,
		priceForTelemedicineConsultation: 125,
		priceForSupportActivitiesPlan: 38,
		fixedPriceForHealthPlan: 1211,
		telemedicineDiscount: 3.85,
		saleDiscount: 10,
	},
	[HealthPlanCode.BABY]: {
		priceForPresentConsultation: 130,
		priceForTelemedicineConsultation: 125,
		priceForSupportActivitiesPlan: 39,
		fixedPriceForHealthPlan: 370,
		telemedicineDiscount: 3.85,
		saleDiscount: 10,
	},
};

const HealthPlanPricingCzech: Record<string, HealthPlanPricing> = {
	[HealthPlanCode.DIABETES]: {
		priceForPresentConsultation: 800,
		priceForTelemedicineConsultation: 700,
		priceForSupportActivitiesPlan: 900,
		fixedPriceForHealthPlan: 28500,
		telemedicineDiscount: 12.5,
		saleDiscount: 10,
	},
};

export const HealthPlanPricingSetup: Record<
	string,
	Record<string, HealthPlanPricing>
> = {
	[Country.MEXICO]: HealthPlanPricingMexico,
	[Country.COLOMBIA]: HealthPlanPricingColombia,
	[Country.PERU]: HealthPlanPricingPeru,
	[Country.ECUADOR]: HealthPlanPricingEcuador,
	[Country.DEFAULT]: HealthPlanPricingCzech,
};
